
import UserIcon from '@src/assets/icons/ic_profile.svg';
import React from 'react';
import { Flex } from 'theme-ui';

const defaultProfile = ({ size = '110px', iconSize = '48px' }) => (
  <Flex
    bg="primaryPaleBg"
    sx={{
      color: 'white',
      width: size,
      height: size,
      borderRadius: '50%',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <UserIcon sx={{ width: iconSize, height: iconSize }} />
  </Flex>
);

export default defaultProfile;
